/* unplugin-vue-components disabled */import script from "./lessonMenuItem.vue?vue&type=script&setup=true&lang=js"
export * from "./lessonMenuItem.vue?vue&type=script&setup=true&lang=js"

import "./lessonMenuItem.vue?vue&type=style&index=0&id=e98bda3e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/edu-main-ui-pre/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e98bda3e"]])

export default __exports__